import script from "./Navigation-block.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation-block.vue?vue&type=script&setup=true&lang=js"

import "./Navigation-block.vue?vue&type=style&index=0&id=5ff8b6f5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff8b6f5"]])

export default __exports__